import { render } from "./copyTrade.vue?vue&type=template&id=2b365aa6"
import script from "./copyTrade.vue?vue&type=script&lang=js"
export * from "./copyTrade.vue?vue&type=script&lang=js"

import "./copyTrade.vue?vue&type=style&index=0&id=2b365aa6&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__